<template>
  <div>
    <b-card header="Parâmetros">
      <b-row>
        <b-col>
          <b-form-group label="Tipo de Relatório">
            <b-form-radio
              v-model="reportType"
              value="protocol"
              @change="clearParameters"
              >Protocolo</b-form-radio
            >
            <b-form-radio
              v-model="reportType"
              value="user"
              @change="clearParameters"
              >Usuário</b-form-radio
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="reportType === 'protocol'" cols="3">
          <b-form-group label="Protocolo">
            <b-form-input v-model="filter.protocol"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="reportType === 'user'" cols="3">
          <b-form-group label="Usuários" description="Selecione o usuário">
            <b-form-select
              v-model="filter.user"
              :options="companyUsersList"
              :select-size="5"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="*" class="ml-3">
          <b-button @click="clearParameters">Limpar</b-button>
        </b-col>
        <b-col cols="*" class="ml-2">
          <b-button
            :disabled="filter.user == null && filter.protocol == null"
            @click="generateReport"
            ><i class="fas fa-print" aria-hidden="true" /> Gerar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { auditReportByProtocol, auditReportByUser } from "../../api/reports";
import { getCompanyUsers } from "../../api/company";
import NProgress from "nprogress"; // progress bar

export default {
  name: "CommitteeReport",
  data() {
    return {
      reportType: null,
      companyUsers: {},
      filter: {
        user: null,
        protocol: null,
      },
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    isMasterUser() {
      return this.profile.role === "root";
    },
    companyUsersList() {
      const users = [];
      for (const user of Object.values(this.companyUsers)) {
        users.push({ value: user._id, text: `${user.name} ${user.surname}` });
      }
      return users;
    },
  },
  async created() {
    if (!this.profile.company) {
      return; // Usuário root ou profile não carregado
    }
    try {
      const response = await getCompanyUsers(this.profile.company);
      this.companyUsers = response.data.reduce((obj, user) => {
        obj[user["_id"]] = user;
        return obj;
      }, {});
    } catch (error) {
      if (error.response.status === 403) {
        this.$bvToast.toast(error.response.data, {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } else {
        this.$bvToast.toast(error.response.statusText, {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      }
    }
  },
  methods: {
    clearParameters() {
      this.filter.user = null;
      this.filter.protocol = null;
    },
    async generateReport() {
      NProgress.start();
      let response;
      try {
        if (this.reportType === "protocol") {
          response = await auditReportByProtocol(this.filter.protocol);
        } else if (this.reportType === "user") {
          response = await auditReportByUser(this.filter.user);
        }
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        NProgress.done(); // finish progress bar
        return;
      }

      const { reportId } = response.data;
      const link = `${window.location.origin}/api/reports/download/${reportId}`;
      const a = document.createElement("a");
      a.setAttribute("download", "");
      a.setAttribute("href", link);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      NProgress.done(); // finish progress bar
    },
  },
};
</script>
